import { useNavigate } from "react-router-dom";
import { X } from "lucide-react";
import { STORES, useStore } from "@/context/StoreContext";

/** Three-store segmented switcher (GIVA pattern): Silver / Gold / Coins. */
export default function StoreSwitcher() {
  const { store, storeDef, setStore, storePromptSeen, setStorePromptSeen } = useStore();
  const navigate = useNavigate();

  return (
    <div className="bg-ivory border-b border-brand/10">
      <div className="container-x flex flex-col items-center py-2.5 gap-2">
        <div className="inline-flex rounded-full border border-brand/25 bg-white p-1" data-testid="store-switcher" role="tablist">
          {Object.values(STORES).map((s) => (
            <button
              key={s.key}
              role="tab"
              aria-selected={store === s.key}
              onClick={() => { setStore(s.key); navigate(s.path); }}
              className={`px-5 sm:px-7 py-1.5 rounded-full text-sm font-medium transition-colors btn-press ${
                store === s.key ? "bg-brand text-ivory" : "text-ink-2 hover:text-brand"
              }`}
              data-testid={`store-switch-${s.key}`}
            >
              {s.label}
            </button>
          ))}
        </div>
        {!storePromptSeen && (
          <div className="flex items-center gap-3 text-xs text-ink-2" data-testid="store-switch-prompt">
            <span>
              You are on the <strong className="text-brand">{storeDef.name}</strong> store — switch above to explore the others.
            </span>
            <button onClick={setStorePromptSeen} className="text-ink-2 hover:text-brand" aria-label="Dismiss" data-testid="store-prompt-dismiss">
              <X size={13} />
            </button>
          </div>
        )}
      </div>
    </div>
  );
}
